import { computed, type ComputedRef } from "vue";
import type { DashboardRole } from "@/types/dashboard";
import { getReportLabelByRole, getReportLabelsByRole, type ReportLabelKey, type ReportLabels } from "@/utils/reportLabels";

export function useReportLabels(role: ComputedRef<DashboardRole | string | null | undefined> | DashboardRole | string | null | undefined) {
  const resolvedRole = computed(() => {
    if (role && typeof role === "object" && "value" in role) {
      return role.value;
    }

    return role;
  });

  const labels = computed<ReportLabels>(() => getReportLabelsByRole(resolvedRole.value));

  const label = (key: ReportLabelKey) => getReportLabelByRole(resolvedRole.value, key);

  return {
    labels,
    label,
    isClient: computed(() => String(resolvedRole.value || "").toLowerCase() === "client"),
  };
}
